import { OnInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({ selector: '[autofocus]' })
export class AutofocusDirective implements OnInit {

    private focus = true;

    @Input()
    set autofocus(value: boolean | string) {
        this.focus = value === true || value === 'true' || value === '';
    }

    constructor(private hostElement: ElementRef) { }

    ngOnInit() {
        if (this.focus) {
            setTimeout(() => {
                const input = <HTMLInputElement>this.hostElement.nativeElement;
                input.focus();
                input.setSelectionRange(0, 0);
            }, 0);
        }
    }
}